import { instance } from '../../../util/http'
import apis from '../../../config/apis'

const unifiedOrder = (orderNo, openId) => {
    return instance.post(apis.Payment.Wxpay.UnifiedOrder, {
        orderNo: orderNo,
        openId: openId
    })
}
const queryOrder = (queryNo, queryType) => {
    return instance.get(apis.Payment.Wxpay.QueryOrder + "?queryOrderNo=" + queryNo + "&queryType=" + queryType)
}
export default {
    unifiedOrder,
    queryOrder
}